import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {IconButton} from '../../../../../../libs/shared/ui/src/components/buttons/iconButton';
import {SimpleDropdown} from '../../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdown';
import {
  PopoverCoordinator,
  PopoverTransferProps,
} from '../../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {UserTheme} from '../../../../../../libs/shared/ui/src/theme/themeTypes';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

export interface MessageViewerVisitorUrlPopoverProps {
  url?: string;
  onPopoverToggle?: (arg: boolean) => void;
  hasSmallIcon?: boolean;
}

/*
 * Style.
 */

const StyledSimpleDropdownDiv = styled.div`
  width: 300px;
  padding: 8px 16px;
`;

const StyledSimpleDropdownHeaderDiv = styled.div`
  display: flex;
  flex-flow: row;
  color: ${(p) => p.theme.greys.shade70};
  margin-bottom: 8px;
`;

const StyledSimpleDropdownItemDiv = styled.div`
  display: flex;
  flex-flow: row;
  white-space: initial;

  a {
    color: ${(p) => p.theme.interactiveText};
    overflow-wrap: anywhere;
  }
`;

/*
 * Component.
 */

export const MessageViewerVisitorUrlPopover: FC<MessageViewerVisitorUrlPopoverProps> = (props) => {
  const theme = useUserTheme();

  return (
    <PopoverCoordinator
      renderButton={(isOpen) => renderVisitorButton(theme, isOpen, props.hasSmallIcon)}
      renderModal={(popoverProps) => renderVisitorPopover(popoverProps, props)}
      onPopoverToggle={props.onPopoverToggle}
    />
  );
};

/*
 * Rendered popover.
 */

function renderVisitorPopover(
  popoverProps: PopoverTransferProps,
  props: MessageViewerVisitorUrlPopoverProps,
) {
  const {url} = props;

  return (
    <SimpleDropdown {...popoverProps}>
      <StyledSimpleDropdownDiv>
        <StyledSimpleDropdownHeaderDiv>Visitor Source URL</StyledSimpleDropdownHeaderDiv>
        <StyledSimpleDropdownItemDiv>
          <a href={url} target="_blank" rel="noreferrer">
            {url}
          </a>
        </StyledSimpleDropdownItemDiv>
      </StyledSimpleDropdownDiv>
    </SimpleDropdown>
  );
}

/*
 * Helpers.
 */

function renderVisitorButton(theme: UserTheme, isOpen: boolean, hasSmallIcon?: boolean) {
  return (
    <IconButton
      color={theme.greys.shade80}
      hoverColor={theme.greys.shade80}
      iconName={hasSmallIcon ? 'visitorSourceUrlSmall' : 'visitorSourceUrl'}
      label={<Trans id="message-viewer-visitor">Visitor URL</Trans>}
      hasHover={isOpen}
    />
  );
}
